
import Vue from 'vue';
import { ChatMessage } from '@/model';
import ChatMarkdown from '@/components/ChatMarkdown.vue';

export default Vue.extend({
  name: 'ChatPanel',
  components: { ChatMarkdown },

  props: {
    history: { type: Array as () => ChatMessage[], default: () => [] },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Ask a question...' },
    initialPrompt: { type: String, default: '' },
  },

  data() {
    return {
      prompt: this.initialPrompt,
      copiedIndex: null as number | null,
    };
  },

  computed: {
    isStreaming(): boolean {
      return this.loading
        && this.history.length > 0
        && this.history[this.history.length - 1].role === 'assistant';
    },
  },

  watch: {
    history() {
      this.$nextTick(() => {
        const el = this.$refs.chatMessages as HTMLElement | undefined;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
  },

  methods: {
    focusInput() {
      (this.$refs.promptInput as any)?.focus?.();
    },
    isStreamingMessage(index: number): boolean {
      return this.isStreaming && index === this.history.length - 1;
    },
    send() {
      if (!this.prompt.trim() || this.loading) return;
      this.$emit('send', this.prompt);
      this.prompt = '';
    },
    copyMessage(content: string, index: number) {
      navigator.clipboard.writeText(content);
      this.copiedIndex = index;
      setTimeout(() => { this.copiedIndex = null; }, 1500);
    },
  },
});
